export enum Size {
  xsmall = "xsm",
  small = "sm",
  medium = "md",
  large = "lg",
  xlarge = "xlg",
  xxlarge = "xxlg",
  full = "full",
}
